// extracted by mini-css-extract-plugin
module.exports = {"Auth":"Auth__Auth__2YUr1","Input":"Auth__Input__MXqRP"};